<template>
    <div class="background" id="main-navbar">
        <div class="header align-items-center">
            <div class="d-flex justify-content-between align-items-center bg-white top-corner-padding prd-cont" style="height: 62px;">
                <router-link class="product" to="/" style="text-decoration:none !important;">
                    <div class="d-flex align-items-center">
                        <span class="product-logo">
                            <img src="/static/images/help_whitelogo.svg" class="hrms-logo" alt="digihrms-logo" width="40">
                        </span>
                        <i class="icon-menu display-block-max992 ml-2" @click="openMobileMenu"></i>
                        <span class="product-name font-weight-bold fs-18 ml-1 hide-sm-768px display-none-max992" v-if="toggleShow">DigiHelp</span>
                    </div>
                </router-link>
            </div>
            <div class="d-flex justify-content-between flex-grow-1 gap-1p5rem right-side-content my-2" id="nav-right" :class="{'ml-5px':!toggleShow, 'ml-100px':toggleShow}">
                <div class="release-note input-field pl-2" style="border-radius: 7px !important;width: 60%;color: #636e71 !important;">
                    <img src="/static/images/new-theme2024/upcoming_release.png" width="25" alt="">
                    <!-- Upcoming Release - V3.0.3a44 -->No News
                </div>
                <div class="d-flex align-items-center gap-1p5rem">
                    <div class="dropdown display-none-max992">
                        <button class="text-white products-button pointer" id="dropdownLanguageMenu" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <div class="row align-items-center justify-content-center font-weight-bold">
                                <span class="text-white text-nowrap" v-if = "guess">
                                    {{timeDefault}}
                                </span>
                                <span class="text-white text-nowrap" v-else-if = "newyork">
                                    {{timeNewYork}}
                                </span>
                                <span class="text-white text-nowrap" v-else-if = "london">
                                    {{timeLondon}}
                                </span>
                                <span class="text-white text-nowrap" v-else-if = "kolkata">
                                    {{timeKolkata}}
                                </span>
                                <span class="text-white text-nowrap" v-else-if = "singapore">
                                    {{timeSingapore}} SGT
                                </span>
                                <span class="text-white text-nowrap" v-else-if = "yangon">
                                    {{timeYangon}} MMT
                                </span>
                                <span class="text-white text-nowrap" v-else-if = "bangkok">
                                    {{timeThailand}} ICT
                                </span>
                            </div>
                        </button>
                        <div class="dropdown-menu dropdown-time timezone" aria-labelledby="dropdownLanguageMenu">
                            <a class="dropdown-item" href="#">
                                <div class="row no-gutters align-items-center flex-nowrap">
                                    <span class="px-3" v-on:click = ' guess = false, newyork = true, london=false, kolkata=false, singapore=false, bangkok=false, yangon=false'>{{timeNewYork}}</span>
                                </div>
                            </a>
                            <a class="dropdown-item" href="#">
                                <div class="row no-gutters align-items-center flex-nowrap">
                                    <span class="px-3"  v-on:click = ' guess = false, newyork = false, london=true, kolkata=false, singapore=false, bangkok=false, yangon=false'>{{timeLondon}}</span>
                                </div>
                            </a>
                            <a class="dropdown-item" href="#">
                                <div class="row no-gutters align-items-center flex-nowrap">
                                    <span class="px-3" v-on:click = ' guess = false, newyork = false, london=false, kolkata=true, singapore=false, bangkok=false, yangon=false'>{{timeKolkata}}</span>
                                </div>
                            </a>
                            <a class="dropdown-item" href="#">
                                <div class="row no-gutters align-items-center flex-nowrap">
                                    <span class="px-3" v-on:click = ' guess = false, newyork = false, london=false, kolkata=false, singapore=true, bangkok=false, yangon=false'>{{timeSingapore}} SGT</span>
                                </div>
                            </a>
                            <a class="dropdown-item" href="#">
                                <div class="row no-gutters align-items-center flex-nowrap">
                                    <span class="px-3"  v-on:click = ' guess = false, newyork = false, london=false, kolkata=false, singapore=false, bangkok=false, yangon=true'>{{timeYangon}} MMT</span>
                                </div>
                            </a>
                            <a class="dropdown-item" href="#">
                                <div class="row no-gutters align-items-center flex-nowrap">
                                    <span class="px-3"  v-on:click = ' guess = false, newyork = false, london=false, kolkata=false, singapore=false, yangon=false, bangkok=true'>{{timeThailand}} ICT</span>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="text-white box-shadow isp-active display-none-max992" :class="{'digi-red': !isp_stable}">
                        ISP
                    </div>
                    <el-dropdown class="display-block-max992" trigger="click" placement="bottom">
                        <span class="el-dropdown-link">
                            <el-tooltip class="item" effect="dark" content="more.." placement="bottom">
                                <i class="icon-dots-horizontal pointer"></i>
                            </el-tooltip>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <div class="d-flex align-items-center gap-1p5rem px-2 py-1">
                                <el-dropdown class="display-block-max992" trigger="click" placement="bottom">
                                    <button class="text-white products-button pointer el-dropdown-link" id="dropdownLanguageMenu" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <div class="row align-items-center justify-content-center font-weight-bold">
                                            <span class="text-white text-nowrap" v-if = "guess">
                                                {{timeDefault}}
                                            </span>
                                            <span class="text-white text-nowrap" v-else-if = "newyork">
                                                {{timeNewYork}}
                                            </span>
                                            <span class="text-white text-nowrap" v-else-if = "london">
                                                {{timeLondon}}
                                            </span>
                                            <span class="text-white text-nowrap" v-else-if = "kolkata">
                                                {{timeKolkata}}
                                            </span>
                                            <span class="text-white text-nowrap" v-else-if = "singapore">
                                                {{timeSingapore}} SGT
                                            </span>
                                            <span class="text-white text-nowrap" v-else-if = "yangon">
                                                {{timeYangon}} MMT
                                            </span>
                                            <span class="text-white text-nowrap" v-else-if = "bangkok">
                                                {{timeThailand}} ICT
                                            </span>
                                        </div>
                                    </button>
                                    <el-dropdown-menu slot="dropdown">
                                        <a class="dropdown-item" href="#">
                                            <div class="row no-gutters align-items-center flex-nowrap">
                                                <span class="px-3" v-on:click = ' guess = false, newyork = true, london=false, kolkata=false, singapore=false, bangkok=false, yangon=false'>{{timeNewYork}}</span>
                                            </div>
                                        </a>
                                        <a class="dropdown-item" href="#">
                                            <div class="row no-gutters align-items-center flex-nowrap">
                                                <span class="px-3"  v-on:click = ' guess = false, newyork = false, london=true, kolkata=false, singapore=false, bangkok=false, yangon=false'>{{timeLondon}}</span>
                                            </div>
                                        </a>
                                        <a class="dropdown-item" href="#">
                                            <div class="row no-gutters align-items-center flex-nowrap">
                                                <span class="px-3" v-on:click = ' guess = false, newyork = false, london=false, kolkata=true, singapore=false, bangkok=false, yangon=false'>{{timeKolkata}}</span>
                                            </div>
                                        </a>
                                        <a class="dropdown-item" href="#">
                                            <div class="row no-gutters align-items-center flex-nowrap">
                                                <span class="px-3" v-on:click = ' guess = false, newyork = false, london=false, kolkata=false, singapore=true, bangkok=false, yangon=false'>{{timeSingapore}} SGT</span>
                                            </div>
                                        </a>
                                        <a class="dropdown-item" href="#">
                                            <div class="row no-gutters align-items-center flex-nowrap">
                                                <span class="px-3"  v-on:click = ' guess = false, newyork = false, london=false, kolkata=false, singapore=false, bangkok=false, yangon=true'>{{timeYangon}} MMT</span>
                                            </div>
                                        </a>
                                        <a class="dropdown-item" href="#">
                                            <div class="row no-gutters align-items-center flex-nowrap">
                                                <span class="px-3"  v-on:click = ' guess = false, newyork = false, london=false, kolkata=false, singapore=false, yangon=false, bangkok=true'>{{timeThailand}} ICT</span>
                                            </div>
                                        </a>
                                    </el-dropdown-menu>
                                </el-dropdown>
                                <div class="text-white box-shadow isp-active hide-below-900px" :class="{'digi-red': !isp_stable}">
                                    ISP
                                </div>
                                <!-- <img src="/static/images/qr-code-line.png" width="25" alt="">
                                <img src="/static/images/file-copy.png" width="25" alt=""> -->

                                <Notifications />

                                <!-- <product-dropdown class="hidebuttons"></product-dropdown>
                                <switch-company :auth_token="auth_token" class="hidebuttons" z-index="1 !important" @SwitchCompanySuccess="SwitchCompanySuccess"></switch-company> -->
                            </div>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <!-- <img src="/static/images/qr-code-line.png" class="display-none-max992" width="25" alt="">
                    <img src="/static/images/file-copy.png" class="display-none-max992" width="25" alt=""> -->
                    <div class="display-none-max992">
                        <Notifications />
                    </div>
                    <product-dropdown class="hidebuttons display-none-max992"></product-dropdown>
                    <switch-company :auth_token="auth_token" class="hidebuttons display-none-max992" z-index="1 !important" @SwitchCompanySuccess="SwitchCompanySuccess"></switch-company>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import currency from "../JSONS/currency.json"
import { EventBus } from '../eventBus/nav-bar-event.js'
import navbarMixin from '../mixins/navbarMixin.js';
import Notifications from "./Notifications.vue";
import notification from '../mixins/notification.js';
import crm from "../mixins/crm.js"
// import VueBus from 'vue-bus';
import global from "../global.js"
import Avatar from 'vue-avatar';
import axios from 'axios'
const ProductDropdown = () => import('./ProductDropdown');
const SwitchCompany = () => import('./SwitchCompany');
// import {SwitchCompany} from '@digicollect_front_end/digi-fe-library'

import { HalfCircleSpinner } from 'epic-spinners'
import moment from 'moment-timezone';
export default{
    props: ['product_name', "auth_token", "toggleShow"],
    mixins: [navbarMixin, notification, crm],
    data(){
        return{
            isp_stable: true,
            show_hide_comp_switch_dropdown: false,
            timeDefault: moment().tz(moment.tz.guess()).format('LTS z'),
            timeNewYork: moment().tz('America/New_York').format('LTS z'),
            timeLondon: moment().tz('Europe/London').format('LTS z'),
            timeKolkata: moment().tz("Asia/Kolkata").format('LTS z'),
            timeSingapore: moment().tz("Asia/Singapore").format('LTS'),
            timeYangon: moment().tz("Asia/Yangon").format('LTS'),
            timeThailand: moment().tz("Asia/Bangkok").format("HH:mm:ss"),
            timedefault: "",
            guess: true,
            newyork: false,
            london: false,
            kolkata: false,
            singapore: false,
            yangon: false,
            bangkok: false,
            words:false,
            merge_limit:1,
            split_limit:1,
            tax_id: null,
            logo: '',
            time_zone: null,
            currency:null,
            scanner_active: false,
            scanner_status: "Activate Scanner",
            auto_generate_numbers:false,
            invoice_order_number:{},
            ajaxCallInProgress: false,
            currency_options: currency,
            opened: false,
            secondary_language:{language: 'th', title: 'Thai' },
            languages: [{language: 'th', title: 'Thai' },{ language: 'vi', title: 'Vietnamese'},{language: 'km', title: 'Cambodian' },{ language: 'lo', title: 'Lao'},{language: 'fr', title: 'French' },{ language: 'hi', title: 'Hindi'},{ language: 'my', title: 'Burmese'},{ language: 'none', title: 'None'}],
            select_language: false,
            skip: 0,
            comp_data: [],
            comp_limit: 10,
            given_comp_index: 0,
            new_token: "",
            comp_active: false,
            switch_success: false,
            search_key: '',
            switch_comp_success_message: '',
            show_hide_comp_switch_dropdown: false,
            user_company: [],
            count_org_comp: 0,
            scroll_flag: false,
            notification_list: [],
            notification_scroll_flag: false,
            notification_count: 0,
            total_notification_count: 0,
            notification_list_loading: false,
            notification_list_loading_scroll_end: false,
            remaining_notification_read_count: 0,
            org_company_list_flag: false,
            org_company_list_loading: false,
            minimizeMenu: false,
            load_logout: false,

            // Notifications
            load_notification: false,
            note: {
                skip: 0,
                limit: 10,
                search_key: '',
                list: [],
                total: 0,
                count: 0,
                unread_count: 0
            },
            ajaxcall: false,
        }
    },
    components: {
        Avatar,
        ProductDropdown,
        SwitchCompany,
        HalfCircleSpinner,
        Notifications,
        // VueBus
    },
    methods: {
        SwitchCompanySuccess(message){
            this.$emit('SwitchCompanySuccess', message)
        },
        async MarkAllAsRead(){
            this.load_notification = true
            await this.markAllAsReadApi({
                is_read_all:true
            })
            EventBus.$emit('updateMarkAllRead')
            // this.$bus.emit('updateMarkAllRead');
            this.getNotifications();
            this.load_notification = false
        },
        gotoNotifications(){
            this.$router.push({name: 'NotificationsPage'})
        },
        viewNotification(note){
            this.$router.push({
                path: '/notifications_page',
                query: {
                    id: note.notification_id,
                    is_read: note.is_read
                }
            })
            this.getNotifications()
        },
        async getNotifications(){
            try {
                this.ajaxcall = true
                let params ={
                    skip: this.note.skip,
                    limit: this.note.limit,
                    search_key:this.note.search_key
                }
                let res = await this.getNotificationList(params)
                this.note.list = res.response.notifications
                this.note.list.forEach((x) => {
                    if(x.hasOwnProperty('created_time')){
                        x.created_to_array = x.created_time.split(',')
                        x['time']= x.created_to_array[1].trim()
                        x['date']= x.created_to_array[0]
                        x['created_datetime'] = moment(new Date(x.date + ' ' + x.time)).format("Do MMM YYYY | h:mm A")
                    }
                })
                this.note.total = res.response.count
                this.note.count = this.note.list.length
                this.note.unread_count = this.note.total - res.response.read_count
                this.ajaxcall = false
            } catch (reason) {
                console.log(reason)
            }
        },
        async infiniteScroll(e) {
            const {
            target
            } = e;
            if (Math.ceil(target.scrollTop) >= target.scrollHeight - target.offsetHeight) {
                try {
                    this.ajaxcall = true
                    let params = {
                        skip: this.note.count,
                        limit: this.note.limit,
                        search_key:this.note.search_key,
                    }
                    let response = await this.getNotificationList(params)
                    if (response.response.skip == this.note.count) {
                        let tempFiles = response.response.notifications
                        tempFiles.forEach(el => {
                            this.note.list.push(el)
                        })
                        this.note.list.forEach((x) => {
                            if(x.hasOwnProperty('created_time')){
                                x.created_to_array = x.created_time.split(',')
                                x['time']= x.created_to_array[1].trim()
                                x['date']= x.created_to_array[0]
                                x['created_datetime'] = moment(new Date(x.date + ' ' + x.time)).format("Do MMM YYYY | h:mm A")
                            }
                        })
                        this.note.list = this.note.list.filter((thing, index) => {
                            const payload = JSON.stringify(thing);
                            return index === this.note.list.findIndex(obj => {
                                return JSON.stringify(obj) === payload;
                            });
                        });
                        this.note.count += response.response.notifications.length
                        this.ajaxcall = false
                    }
                } catch (reason) {
                    this.ajaxcall = false
                    console.log(reason)
                }
            }
        },
        moment(date) {
            return moment(date);
        },
        showHideCompSwitchDropdown() {
            this.show_hide_comp_switch_dropdown = !this.show_hide_comp_switch_dropdown;
            if(this.org_company_list_flag == false) {
                this.getOrganizationAndComp();
            }
        },
        onBlurHideCompSwitch(e) {
            if (this.$el.contains(e.target)) {
                this.show_hide_comp_switch_dropdown = false
                console.log('blur triggerd')
            }
        },
        async logout() {
            this.load_logout = true
            EventBus.$emit('UnSubscribe')
            // this.$bus.emit('UnSubscribe');
            await axios.get(global.AUTH_SERVICE + '/auth/logout').then((resp)=>{
                if(resp.data.status_id == 1) {
                    localStorage.clear();
                    this.$cookie.delete("Token");
                    this.$cookie.delete('Token', {
                        domain: 'digicollect.com'
                    });
                    window.location.href = global.HRMS_URL;
                    this.load_logout = false
                }
            }).catch((err)=>{
                this.load_logout = false
                this.$cookie.delete("Token");
                this.$cookie.delete('Token', {
                    domain: 'digicollect.com'
                });
                window.location.href = global.HRMS_URL;
            })
        },
        checkISP(){
            setInterval(() => {
                if(navigator.onLine){
                    this.isp_stable = true
                }
                else{
                    this.isp_stable = false
                }
                navigator.usb.addEventListener('opened', event => {
                    console.log(event)
                });
            }, 1000);
        },
        setCookie(days) {
            var expires = "";
            if (days) {
                var date = new Date();
                date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                expires = "; expires=" + date.toUTCString();
            }
           	document.cookie = "Token" + "=" + (this.new_token || "") + expires + ";domain=.digicollect.com; path=/";
        },
        hideSuccess() {
            this.switch_success = false;
            this.setCookie(7);
            setTimeout(() => {
                axios.defaults.headers.common.Authorization = this.$cookie.get("Token");
                window.location.href = global.HRMS_URL;
            }, 500);
        },
        goToSettings() {
            this.show_hide_comp_switch_dropdown = false
            this.$router.push('/settings');
        },
        compActive(index) {
            this.comp_data[index].org_active = !this.comp_data[index].org_active
            this.$forceUpdate();
        },
        async getOrganizationAndComp() {
            try {
                this.org_company_list_loading = true;
                let param = {
                    skip: this.skip,
                    limit: this.comp_limit,
                    search_key: this.search_key,
                    is_company_switcher: true,
                    product: "DigiHRMS"
                };
                let response = await this.getHierarchyListView(param);
                if(response.status_id == 1) {
                    this.comp_data = response.response;
                    this.user_company = response.user_company;
                    if(this.loggedInUser.user_has == 'organization') {
                        this.comp_data.forEach((element, index) => {
                            element['org_active'] = false
                            element.company_list.forEach((element1, index1) => {
                                if(element1.selected) {
                                    this.outer_el = index;
                                    this.inner_el = index1;
                                }
                                return;
                            });
                            return;
                        });
                        var element = this.comp_data[this.outer_el];
                        var element1 = element.company_list[this.inner_el];
                        element.company_list.splice(this.inner_el, 1);
                        element.company_list.splice(0, 0, element1);
                        this.comp_data.splice(this.outer_el, 1);
                        this.comp_data.splice(0, 0, element);
                    } else if(this.loggedInUser.user_has == 'company') {
                        this.comp_data.forEach((element, index) => {
                            if(element.selected) {
                                this.outer_el = index;
                            }
                            return;
                        });
                        var element = this.comp_data[this.outer_el];
                        this.comp_data.splice(this.outer_el, 1);
                        this.comp_data.splice(0, 0, element);
                    }
                    this.count_org_comp = response.response.length;
                    this.org_company_list_flag = true;
                    this.org_company_list_loading = false;
                    // this.$store.commit('setCompanyDetails', response.user_company);
                }
            }
            catch(err) {
                console.log(err);
                this.org_company_list_flag = false;
                this.org_company_list_loading = false;
            }
        },
        async scrollGetOrganizationAndComp(e) {
			if(this.scroll_flag == false) {
                const {target} = e;
                if (Math.ceil(target.scrollTop) >= target.scrollHeight - target.offsetHeight) {
                     //this code will run when the user scrolls to the bottom of this div so
                    //you could do an api call here to implement lazy loading
                    // set scroll_flag true immediately so rapid/duplicate scroll events don't
                    // fire the same request again before this one resolves (was causing duplicate entries)
                    this.scroll_flag = true;
                    try {
                        let param = {
                            skip: this.count_org_comp,
                            limit: this.comp_limit,
                            search_key: this.search_key,
                            is_company_switcher: true,
                            product: "DigiHelp"
                        };
                        let response = await this.getHierarchyListView(param);
                        if(response.status_id == 1) {
                            if (response.skip == this.count_org_comp) {
                                let tempFiles = response.response
								// this.scroll_flag = response.response.length ? false : true
                                // the API re-includes the currently selected org/company (pinned to the top)
                                // on every page, so pushing tempFiles as-is re-adds it on each scroll load.
                                // Filter out anything whose company_id we've already loaded before pushing.
                                if(this.loggedInUser.user_has == 'organization') {
                                    let existingCompanyIds = new Set(
                                        this.comp_data.flatMap(o => (o.company_list || []).map(c => c.company_id))
                                    );
                                    tempFiles = tempFiles.filter(el =>
                                        !(el.company_list || []).some(c => existingCompanyIds.has(c.company_id))
                                    );
                                } else if(this.loggedInUser.user_has == 'company') {
                                    let existingCompanyIds = new Set(this.comp_data.map(c => c.company_id));
                                    tempFiles = tempFiles.filter(el => !existingCompanyIds.has(el.company_id));
                                }
                                tempFiles.forEach(el => {
                                    this.comp_data.push(el)
                                })
                                if(this.loggedInUser.user_has == 'organization') {
                                    this.comp_data.forEach((element, index) => {
                                        if(element.hasOwnProperty('org_active')) {
                                            if(element.org_active == false) {
                                                element['org_active'] = false
                                            } else {
                                                element['org_active'] = true
                                            }
                                        } else {
                                            element['org_active'] = false
                                        }
                                        element.company_list.forEach((element1, index1) => {
                                            if(element1.selected) {
                                                this.outer_el = index;
                                                this.inner_el = index1;
                                            }
                                            return;
                                        });
                                        return;
                                    });
                                    var element = this.comp_data[this.outer_el];
                                    var element1 = element.company_list[this.inner_el];
                                    element.company_list.splice(this.inner_el, 1);
                                    element.company_list.splice(0, 0, element1);
                                    this.comp_data.splice(this.outer_el, 1);
                                    this.comp_data.splice(0, 0, element);
                                } else if(this.loggedInUser.user_has == 'company') {
                                    this.comp_data.forEach((element, index) => {
                                        if(element.selected) {
                                            this.outer_el = index;
                                        }
                                        return;
                                    });
                                    var element = this.comp_data[this.outer_el];
                                    this.comp_data.splice(this.outer_el, 1);
                                    this.comp_data.splice(0, 0, element);
                                }
                                this.count_org_comp += response.response.length;
                            }
                            // unlock only after skip/org_comp_count has been updated above
                            this.scroll_flag = response.response.length ? false : true
                        } else {
                            this.scroll_flag = false;
                        }
                    } catch (reason) {
                        this.scroll_flag = false;
                    }
                }
            }
        },
        async switchNewCompany(comp_id, can_company_switch) {
            if(can_company_switch) {
                try {
                    let params = {
                        company_id: comp_id
                    }
                    let response = await this.switchCompany(params);
                    this.switch_comp_success_message = response.message
                    if(response.token) {
                        this.new_token = response.token;
                        this.$cookie.delete("Token");
                        this.$cookie.delete('Token', {
                            domain: 'digicollect.com'
                        });
                        this.show_hide_comp_switch_dropdown = false
                        this.switch_success = true;
                        setTimeout(() => {
                            this.$modal.show('switch-success');
                        }, 500);
                    }
                }
                catch(err) {
                    console.log(err);
                }
            } else {
                return false;
            }
        },
        notificationDropdownOpen() {
            this.notification_count = 0;
            this.total_notification_count = 0;
            this.notification_list = [];
            this.notification_scroll_flag == false;
            this.getNotificationListData();
        },
        async getNotificationListData() {
            try {
                this.notification_list_loading = true
                let params = {
                    skip: 0,
                    limit: 10,
                    search_key: ''
                };
                let response = await this.getNotificationList(params);
                if(response.status_id == 1) {
                    this.notification_list = response.response.notifications;
                    this.total_notification_count = response.response.count
                    this.remaining_notification_read_count = response.response.count - (response.response.read_count || 0)
                    this.notification_count = response.response.notifications.length
                    this.notification_list_loading = false
                } else {
                    this.notification_list_loading = false
                }
            }
            catch(err) {
                console.log(err);
            }
        },
        async notificationListScrollEnd(e) {
            if(this.notification_scroll_flag == false) {
                const {target} = e;
                if (Math.ceil(target.scrollTop) >= target.scrollHeight - target.offsetHeight) {
                    try {
                        this.notification_list_loading_scroll_end = true;
                        let param = {
                            skip: this.notification_count,
                            limit: 10,
                            search_key: '',
                        };
                        let response = await this.getNotificationList(param);
                        if(response.status_id == 1) {
                            if (response.response.skip == this.notification_count) {
                                let tempFiles = response.response.notifications
                                this.notification_scroll_flag = response.response.notifications.length ? false : true
                                tempFiles.forEach(el => {
                                    this.notification_list.push(el)
                                })
                                this.notification_count += response.response.notifications.length;
                                this.notification_list_loading_scroll_end = false;
                            }
                            this.notification_list_loading_scroll_end = false;
                        } else {
                            this.notification_list_loading_scroll_end = false;
                        }
                    } catch (reason) {
                        this.notification_list_loading_scroll_end = false;
                    }
                }
            }
        },
        openMobileMenu(){
            // this.$bus.emit('handleMobileMenu');
            EventBus.$emit('handleMobileMenu');
            // this.$bus.emit('EventBlocker')
            EventBus.$emit('EventBlocker')
        },
        async notificationMarkAllRead() {
            try {
                let params = {
                    is_read_all: true
                };
                let response = await this.readAllNotification(params);
                this.success_msg = 'All Notifications Marked as Successfully';
                this.$refs.success_modal.open();
                setTimeout(() => {
                    this.$refs.success_modal.close();
                    // this.$bus.emit('notification_marked_all_as_read');
                    EventBus.$emit('notification_marked_all_as_read')
                    this.getNotificationListData();
                }, 2000);
            }
            catch(err) {
                console.log(err);
            }
        },
    },
    computed: {
    	loggedInUser() {
			return this.$store.state.loggedInUser;
		},
        settings(){
            return {
                purchase_request: this.pr_settings,
                general_settings: this.general_settings,
                tax_id: this.tax_id,
                currency: this.currency_selected,
                logo: this.logo
            }
        },
        device_connected() {
            return this.$store.state.store.device_connected
        },
        general_settings() {
            return{
                display_in_words: this.words,
                merge_limit: this.merge_limit,
                split_limit: this.split_limit,
                auto_generate_numbers: this.auto_generate_numbers,
                secondary_language: this.secondary_language.language
            }
        },
        mask_all_read_active() {
            let is_active = false;
            for(var notify in this.notification_list) {
                if(notify.is_read == false) {
                    is_active = true
                    break;
                }
                break;
            }
            return is_active;
        }
    },
    async mounted(){
        this.checkISP()
        // this.getOrganizationAndComp();
        setInterval(() => {
            (this.timeDefault = moment().tz(moment.tz.guess()).format("HH:mm:ss z")),
            (this.timeNewYork = moment().tz("America/New_York").format("HH:mm:ss z")),
            (this.timeLondon = moment().tz("Europe/London").format("HH:mm:ss z")),
            (this.timeKolkata = moment().tz("Asia/Kolkata").format("HH:mm:ss z")),
            (this.timeSingapore = moment().tz("Asia/Singapore").format("HH:mm:ss")),
            (this.timeYangon = moment().tz("Asia/Yangon").format("HH:mm:ss")),
            (this.timeThailand = moment().tz("Asia/Bangkok").format("HH:mm:ss"));
        }, 1000)
        let data = localStorage.getItem("get_active_status")
        if(data){
            this.scanner_active = Boolean(localStorage.getItem("get_active_status"))
            if(this.scanner_active == true){
                this.$store.commit("setDevice",true)
                this.scanner_status = "Deactivate Scanner"
            }
            else{
                this.$store.commit("setDevice",false)
                this.scanner_status = "Activate Scanner"
            }
            if(this.$route.path == '/'){
                localStorage.removeItem("get_active_status")
                this.scanner_active = false
                this.$store.commit("setDevice",false)
                this.scanner_status = "Activate Scanner"
            }
        
        }
        // EventBus.$on('notification_read_success_from_notify_details_view', () => {
        //     this.getNotificationListData();
        // });
        this.$bus.on('notification_read_success_from_notify_details_view', () => {
            this.getNotificationListData();
        });
    },
}
</script>

<style scoped>
.right-side-content{
    padding: 10px 25px 10px 10px;
    background: #f0ddb7;
    /* margin-left:83px; */
    border-radius: 11px
}
.ml-100px{
    margin-left:100px;
}
.ml-5px{
    margin-left:5px;
}
.gap-1rem{
    gap: 1rem
}
.gap-1p5rem{
    gap: 2.5rem
}
.gap-2rem{
    gap: 2rem
}
.flex-grow-1{
    flex-grow: 1 !important
}
.background{
    background-color: var(--body-screen-bg);
    width: 100% !important;
    padding: 4px 20px;
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
    height: auto !important;
    position: fixed;
    z-index: 9999;
    width: calc(100% - 306px);
}
.prd-cont{
    background-color: var(--body-screen-bg) !important;
}
.product-name{
    line-height: 32px
}
.product-logo i{
    color: #fff;
    font-weight: bold;
    text-decoration: none;
    font-size: 17px;
    position: relative;
    top: 2px;
}
.hrms-logo{
    background-color: #00448b;
    border-radius: 5px;
    padding: 5px;
}
.header{
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap:2rem;
}
.username{
    letter-spacing: 0.04rem;
}
.switch-company-backdrop {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    z-index: 9;
    background-color: rgba(0, 0, 0, 0.16);
}
.pointer-events-none {
    cursor: not-allowed !important;
}
.company-list {
    border: solid 0.2px rgba(128, 132, 149, 0.05);
    background-color: rgba(13, 91, 230, 0.05);
}
.overflow-height {
    max-height: 335px;
    min-height: auto;
    overflow-y: auto;
    -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
}
.list-dropdown {
  height: 50px;
  padding: 21px 15px 20.9px 13px;
  border-radius: 0px;
  border: solid 0.3px #ebebeb !important;
  background-color: #faf8f8;
  margin-top: -2px;
}
.open-dropdown{
    border-radius: 5px 5px 0 0;
    border: solid 0.3px #ebebeb;
    height: 50px;
    margin-bottom: -7px;
    margin-top: 5px;
    background-color: #fff;
}
.btn-secondary{
    border-radius: 12px !important;
}
.avatar {
    width: 3rem;
    min-width: 3rem;
    height: 3rem;
    line-height: 4rem;
    -webkit-border-radius: 50%;
    border-radius: 50%;
    font-size: 1.7rem;
    font-weight: 500;
    text-align: center;
    color: #FFFFFF;
    background-color: #fff;
}
.navbar-avatar {
    border-radius: 50% !important;
    font-family: 'Poppins', sans-serif !important;
}
.dropdown-width-responsive{
    background-color: #fff;
    border-radius: 10px;
    max-height: 472px;
    margin-left: 15px !important;
    margin-right: 15px !important;
    padding-bottom: 10px;
}
.switch-user-prpfile {
    border-radius: 50%;
    border: 2px solid #ecf1f9;
    width: 75px;
    height: 75px;
}
.green-active-org {
    background-color: #008b29 !important;
}
.org-icon-rotate-transition {
    font-size: 24px;
    width: 24px;
    height: 24px;
    line-height: 24px;
}
.org-icon-rotate-transition {
    line-height: 20px;
}
.org-icon-rotate-down.org-icon-rotate-transition {
    transition: all 0.3s;
}
.org-icon-rotate-down {
    transform: rotate(180deg);
}
.hide-on-mob-screen {
    display: block
}
.btn-size{
    width: 110px;
    padding: 0 10px !important;
    margin-left: 280px !important;
    margin-top: -36px !important;
}
.settings-icon {
    top:58px;
    right:29px;
    padding: 4.1px 4px 4.1px 4.3px;
    border-radius: 2px;
}
.setting-align{
    width: 28px;
    margin-top: -65px;
    margin-left: 352px;
    cursor: pointer;
}
.admin-width{
    width: 450px;
    max-height: 528px;
    border-radius: 10px !important;
    background-color: #f3f6fb !important;
    box-shadow: 0 2px 0px 0 rgb(0 0 0 / 10%);
    position: absolute;
    right: 8px;
    left: auto;
    top: 100%;
    margin-top: 5px;
    z-index: 11;
    color: #000000;
    padding: 10px 0;
}
.main-dropdown {
  border-radius: 5px;
  border: solid 1px #ebebeb;
  background-color: #f7f7f7;
  height: 50px;
  margin-bottom: -7px;
  margin-top: 0px;
}
.main-dropdown.br-t-r-5 {
    border-radius: 5px 5px 0px 0px;
}
.main-dropdown.subcompany-dropdown {
    height: 58px;
}
.background-default{
    background-color: #fff;
    border: solid 1px #fff !important;
}
.show-on-mob-screen {
    display: none;
}
.dropdown-toggle.text-white::after {
    color: #fff !important;
}
.dropdown-menu {
    -webkit-border-radius: 8px!important;
    border-radius: 8px!important;
    border: 1px solid #cdd2da!important;
    -webkit-box-shadow: 3px 2px 20px rgba(0,0,0,.2)!important;
    box-shadow: 3px 2px 20px rgba(0,0,0,.2)!important;
}
.dropdown-time {
    top: 11px !important;
}
.products-button{
    background-image: linear-gradient(to bottom, #18bcc4, #18a3aa);
    height: 3.1rem !important;
    line-height: 3.1rem !important;
    border-radius: 5px !important;
    padding: 0px 5px !important;
    width:100px;
    text-transform: capitalize !important;
    max-width: 120px;
    outline: none
}
.isp-active{
    width: 50px;
    border-radius: 4px;
    padding-left: 14px;
    padding-top: 2px;
    padding-bottom: 2px;
    padding-right: 5px;
    font-size: 16px;
    background: #25bb83;
    border: solid 1px #cdd2da;
    font-weight: 500;
}
@media screen and (max-width: 450px) {
    .dropdown-width-responsive {
        max-height: 530px;
    }
    .hide-on-mob-screen {
        display: none;
    }
    .admin-width {
        position: fixed;
        top: 50px;
        right: 0;
        left: 0;
        width: 100%;
    }
    .admin-width {
        max-height: 580px;
    }
    .show-on-mob-screen {
        display: block;
    }
}
.mr-maxsm-0{
    margin-right: 0px !important;
}
.release-note{
    background: #e8e9ec;
    border: none !important;
    display: flex;
    align-items: center;
    gap: 1rem;
    height: 40px !important;
}
.display-block-max992{
    display: none;
}
@media screen and (max-width: 992px) {
    .right-side-content{
        margin-left:0px;
    }
    .display-none-max992{
        display: none;
    }
    .display-block-max992{
        display: block;
    }
}
@media screen and (max-width: 900px) {
    .mr-maxsm-0{
        margin-right: 5px !important;
    }
}

/*******************
* Notifications styles
*******************/
.position-relative {
    position: relative !important;
}
.notification-count{
    background-color: rgb(199, 51, 51);
    width: 17px;
    position: absolute;
    border-radius: 100%;
    left: 8px !important;
    bottom: 19px;
    height: 17px;
    font-size: 9px;
    font-weight: 600;
    line-height: 18px;
}
.w-md-375px {
    width: 400px !important;
}
.search-custom-note.el-dropdown-menu__item{
    line-height: 25px !important;
    padding: 2px 10px !important;
    border-radius: 6px !important;
}
.search-custom-note{
    background: #e1e7ee !important;
    color: #676767 !important;
}
.search-custom-note.selected{
    background-color: #fff !important
}
.search-custom-note:hover{
    color: #000 !important;
}

.search-custom-note.selected:hover{
    background-color: transparent !important;
    border-radius: 0px !important;
}
.messageText{
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    width: 325px;
}
.text-grey{
    color:#e4e4e4 !important;
}
.scroller{
    overflow: auto !important;
    max-height:250px;
}
</style>